import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class ProjectHasConsumableAnalysisDto {
  consumableId: string;

  consumableName: string;

  @Transform(({ value }) => toEuros(value))
  totalCost = 0;
}
